import React from 'react'
import Box from '../components/Box'

export default function Section1() {
    return (<div className="section">
        <h2>Section I: Classes</h2>
        <Box sectionData={'start'} title={'Add a Class'} body={`1. Tap the “+” button in the Class List toolbar. 2. Enter the name of the class, term name, start date, and end date for the class. a. After  creating  the  first  class  for  each  term  the  term  may  be  selected  from  a  list  by tapping the down arrow next to the term name field. 3. Select standard or weighted grade scale. 4. Tap “Save”.`} />
        <Box title={'Copy a Class'} body={`Note: • Copying a class will duplicate the categories, grade scale, and assignments only.   The roster and entered scores are not copied automatically. 1. Tap the “+” button in the Class List toolbar. 2. Tap the “Copy” button. 3. Select the class to copy.  4. Tap “Yes” to confirm. 5. Enter or select the term. 6. Tap “Save”. `} />
        <Box title={'Edit a Class'} body={`Notes:  • Changing the term start or end date for one class will change the start or end dates for all other classes associated with the same term. 1. Select the class (as described below). 2. Tap the “Manage” button on the bottom toolbar and select “Class” from the menu. 3. You may change the class name, term, start and end dates, or grade scale type.`} />
        <Box title={'Add Class Notes'} body={`1. Select the class as described previously.  2. Tap “Notes”.  3. The note field will slide into view.  4. Enter or edit class notes.  5. Tap “Notes” again to hide the note field. `} />


        <Box title={'Delete a Class'} body={`Note:  •This cannot be undone.  1. Select the “Edit” button in the Class List view. 2. Tap the “-“ button on the class to be deleted. 3. Confirm by tapping the “Delete” button. 4. Confirm again by selecting “Delete Class”.`} />
        <Box title={'Select a Class'} body={`1. Select a class from the Class List view. 
        a. iPad Landscape: The class list view is always displayed on the left side of the screen. 
        b. iPad Portrait: Tap the “Class List” button on the top toolbar of the main screen to display 
        the Class List view. 
        c. iPhone / iPod: The class list is displayed automatically at launch.`} />


        <Box title={'Configure a Grade Scale'} body={`1. Select a class as described previously. 
        2. Tap “Manage” 
        3. Tap “Grade Scale” 
        4. Use the “+” button to add as many grade ranges as desired. 
        5. Tap “Done”`} />


        <Box sectionData={'end'} title={'Copy a Grade Scale'} body={`1. Select the destination class. 
        2. Tap “Manage” 
        3. Tap “Grade Scale” 
        4. Tap “Copy” 
        5. Select the source class. 
        6. Tap “Copy”`} /></div>
    )
}
